import { useMemo } from 'react';

import { WHITELISTED_AI_NARRATIVE_COMPONENT_KEYS } from 'constants/componentKeys/whiteListedAiNarrative.componentKeys';

import { QueryResponse as ComponentListApiResponse } from 'api/queries/getComponentLiteList';

import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useComponentListOptions = (componentList: ComponentListApiResponse[] | undefined) => {
    const componentListOptions = useMemo<ISelectOption<string>[]>(
        () =>
            componentList
                ? componentList
                      .filter((item) =>
                          WHITELISTED_AI_NARRATIVE_COMPONENT_KEYS.includes(item.componentKey as keyof IHashmap),
                      )
                      .map((item) => ({
                          label: item.name,
                          value: item.componentKey,
                          id: item.id,
                      }))
                      .sort((a, b) => a.label.localeCompare(b.label))
                : [],
        [componentList],
    );

    return componentListOptions;
};
